module.exports = __webpack_public_path__ + "img/nav-zhurm.4cdd653c.png";